module.exports = __webpack_public_path__ + "static/media/placeholder-ssvm-dark.0aaad8fc.svg";